import { createContext, FC, PropsWithChildren, useContext } from "react";

import { Locales } from "@simplyk/common";

import { TranslationColumnHeader } from "../sharedComponents/TranslationColumnHeader";

import { TranslationLineLabelsContext } from "@/components/TranslationLine/TranslationLineLabelsContext";

interface TranslationLocales {
  formLocale: Locales;
  translationLocale: Locales;
}

const TranslationLocaleContext = createContext<TranslationLocales | undefined>(undefined);

export const TranslationLocaleProvider: FC<PropsWithChildren<TranslationLocales>> = ({ children, ...locales }) => {
  const languageHeaders = useContext(TranslationLineLabelsContext);

  return (
    <TranslationLocaleContext.Provider value={locales}>
      <TranslationLineLabelsContext.Provider
        value={
          languageHeaders ?? [
            <TranslationColumnHeader
              key="main"
              role="main"
              locale={locales.formLocale}
              organizationCountry={undefined}
            />,
            <TranslationColumnHeader
              key="secondary"
              role="secondary"
              locale={locales.translationLocale}
              organizationCountry={undefined}
            />,
          ]
        }
      >
        {children}
      </TranslationLineLabelsContext.Provider>
    </TranslationLocaleContext.Provider>
  );
};

export const useTranslationLocales = () => useContext(TranslationLocaleContext);
